import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import { getServiceErrorMessage } from "../../../helpers"
import { Context, Transitions } from "../../../types"
import { ResetResult } from "../../../../../../../services/ready-services/studyPlan/studyPlanMutationResolver"

export const restoreMasteryLessonTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  exit: assign<Context>({
    selectedLessonId: null,
    selectedSectionId: null
  }),
  invoke: {
    src: "restoreMasteryLesson",
    onDone: [
      {
        target: "#StudyPlan.teacher_view",
        actions: assign<Context, DoneInvokeEvent<ResetResult>>((ctx, evt) => ({
          snackbar: {
            message: "Lesson progress restored",
            withUndo: evt.data.allowUndo,
            undoEvent: {
              type: "RESET_MASTERY_LESSON",
              contentId: evt.data.contentId,
              allowUndo: false
            }
          }
        }))
      }
    ],
    onError: {
      target: "#StudyPlan.teacher_view.idle",
      actions: assign<Context, DoneInvokeEvent<ResetResult>>((_ctx, evt) => ({
        loading: false,
        snackbar: {
          message: getServiceErrorMessage("toggleResetMasteryLessons", {
            errorReason: evt.data.message
          }),
          withUndo: false,
          error: true
        }
      }))
    }
  }
}
